import { envFlags } from '@thoughtspot/env-flags';
import { create } from '@thoughtspot/logger';
import { collectEvent, UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
import { DEFAULT_FLAG_VALUE } from './flags.const';
const logger = create('feature-service flags');
class FeatureFlagStore {
    setContext(context) {
        this.context = context;
    }
    getContext() {
        return this.context;
    }
    setFlags(flags) {
        this.flags = flags;
    }
    getFlags() {
        return this.flags;
    }
    getFlag(flag) {
        return this.flags?.[flag];
    }
}
let featureFlagStore;
export function isInitialized() {
    return !!featureFlagStore;
}
export function clearFeatureFlagStore() {
    featureFlagStore = undefined;
}
export function freshInitialize(userContext, flags) {
    featureFlagStore = new FeatureFlagStore();
    featureFlagStore.setContext(userContext);
    featureFlagStore.setFlags(flags);
    collectEvent(new UserAction(userActionTypeEnum.FEATURE_SERVICE_FLAGS_INIT), { context: userContext.toString() });
}
export function initialize(userContext, flags, options = {}) {
    const { shouldOverride = false } = options;
    if (!featureFlagStore || shouldOverride) {
        freshInitialize(userContext, flags);
    }
}
export function isFeatureEnabled(key, options) {
    const launchdarklyValue = featureFlagStore?.getFlag(key);
    let hasURLFlagForJsonObject = false;
    if (launchdarklyValue &&
        typeof launchdarklyValue === 'object' &&
        !options?.disableUrlParam) {
        const updatedLaunchdarklyValue = { ...launchdarklyValue };
        Object.keys(launchdarklyValue).forEach(key => {
            const keyValue = envFlags.getValue(key);
            if (keyValue) {
                updatedLaunchdarklyValue[key] = keyValue;
                hasURLFlagForJsonObject = true;
            }
        });
        if (hasURLFlagForJsonObject)
            return updatedLaunchdarklyValue;
    }
    const urlParamValue = envFlags.getValue(key);
    if (urlParamValue !== undefined &&
        urlParamValue !== null &&
        !options?.disableUrlParam)
        return urlParamValue;
    if (options?.urlParamValue !== undefined &&
        options?.urlParamValue !== null &&
        !options?.disableUrlParam) {
        return options.urlParamValue;
    }
    if (!featureFlagStore) {
        logger.bundleWarn('Attempt to read before feature flag store was initialized');
    }
    return launchdarklyValue ?? DEFAULT_FLAG_VALUE;
}
export function getFeatureFlagValues(ldKeyEnabled, ldKey, tscliFlagValue) {
    const isLdKeyEnabledValue = isFeatureEnabled(ldKeyEnabled.key, ldKeyEnabled.options);
    if (isLdKeyEnabledValue) {
        const ldEnabledValue = isFeatureEnabled(ldKey.key, ldKey.options);
        if (typeof ldEnabledValue === 'object') {
            if (ldKey?.innerKey) {
                return ldEnabledValue[ldKey?.innerKey];
            }
            return ldEnabledValue;
        }
        return ldEnabledValue;
    }
    return tscliFlagValue;
}
//# sourceMappingURL=flags.js.map